export default __webpack_public_path__ + "static/media/other_cards_01.b7e8f78f.png";